export const UPDATE_NETWORK_STATUS = 'UPDATE_NETWORK_STATUS';

export function updateNetworkStatus(status) {
    return {
        type: UPDATE_NETWORK_STATUS,
        payload: status,
    };
}
